module.exports = __webpack_public_path__ + "static/media/create.f06d494f.svg";